// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-split-pane {
  --max-width: 240px;
}
ion-split-pane .menu-pane-visible {
  width: 260px;
}

ion-title {
  font-family: "Yanone Kaffeesatz";
  font-weight: 500;
  letter-spacing: 0.3px;
  text-align: center;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

.userDataIcon {
  font-size: 24px;
}

ion-menu ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu ion-list {
  padding: 2px 0;
}

ion-menu ion-note {
  margin-bottom: 30px;
}

ion-menu ion-list-header,
ion-menu ion-note {
  padding-left: 10px;
}

ion-menu ion-list#inbox-list ion-list-header {
  font-size: 18px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu ion-item.active {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
  color: var(--ion-color-primary);
}

ion-menu ion-item.active ion-icon {
  color: var(--ion-color-primary);
}

ion-menu ion-item ion-icon {
  color: #616e7e;
}

ion-menu ion-item ion-label {
  font-weight: 500;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}

#appVersionCode {
  font-size: small;
  text-align: center;
  padding: 12px;
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAAF;;AAIE;EACE,2EAAA;AADJ;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;;EAEE,kBAAA;AAFF;;AAME;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,sDAAA;EACA,+BAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,eAAA;EACA,oCAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAJF","sourcesContent":["ion-split-pane {\r\n  --max-width: 240px;\r\n\r\n  .menu-pane-visible {\r\n    width: 260px;\r\n  }\r\n}\r\n\r\nion-title {\r\n  font-family: \"Yanone Kaffeesatz\";\r\n  font-weight: 500;\r\n  letter-spacing: 0.3px;\r\n  text-align: center;\r\n}\r\n\r\nion-menu {\r\n  ion-content {\r\n    --background: var(--ion-item-background, var(--ion-background-color, #fff));\r\n  }\r\n}\r\n\r\n.userDataIcon {\r\n  font-size: 24px;\r\n}\r\n\r\nion-menu ion-content {\r\n  --padding-start: 8px;\r\n  --padding-end: 8px;\r\n  --padding-top: 20px;\r\n  --padding-bottom: 20px;\r\n}\r\n\r\nion-menu ion-list {\r\n  padding: 2px 0;\r\n}\r\n\r\nion-menu ion-note {\r\n  margin-bottom: 30px;\r\n}\r\n\r\nion-menu ion-list-header,\r\nion-menu ion-note {\r\n  padding-left: 10px;\r\n}\r\n\r\nion-menu ion-list#inbox-list {\r\n  ion-list-header {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    min-height: 20px;\r\n  }\r\n}\r\n\r\nion-menu ion-item {\r\n  --padding-start: 10px;\r\n  --padding-end: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\nion-menu ion-item.active {\r\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu ion-item.active ion-icon {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu ion-item ion-icon {\r\n  color: #616e7e;\r\n}\r\n\r\nion-menu ion-item ion-label {\r\n  font-weight: 500;\r\n}\r\n\r\nion-note {\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  color: var(--ion-color-medium-shade);\r\n}\r\n\r\n#appVersionCode {\r\n  font-size: small;\r\n  text-align: center;\r\n  padding: 12px;\r\n  opacity: 0.8;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
